import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { EcatService } from 'src/app/services/ecat.service';
import { encryptParam } from 'src/app/utils/encrypt';
import { Router, ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { RemarkMap, EcatUtils } from 'src/app/utils/ecat-util';
import { NzModalService } from 'ng-zorro-antd/modal';
import { VideoModalComponent } from 'src/app/pages/official-website/ecat/video/video-modal.component';
import * as copy from 'copy-to-clipboard';
import { environment } from 'src/environments/environment';
import { SharedDataService } from 'src/app/services/sharedDataService.service';

// --- 原始数据接口 ---
interface RawCategory {
    category1Name: string;
    category2Name: string;
    wechatOrder: number;
    // 其他字段虽然在JSON中有，但暂未用到，可按需添加
    [key: string]: any;
}

// --- 视图模型接口 ---
interface VehicleModel {
    year: number;
    name: string;
}

interface Product {
    id: string;
    image: string;
    name: string;       // 对应 category2Name
    groupName: string;  // 对应 category1Name
    partNumber: string;
    alias?: string;
    status: 'InStock' | 'OutOfStock';
}

interface CategoryView {
    id: string; // 使用 category1Name 作为 ID
    name: string;
    order: number;
}

interface SubCategoryView {
    id: string; // 使用 category2Name 作为 ID
    name: string;
}

@Component({
    selector: 'ecat-mobile-part-list',
    templateUrl: './ecat-mobile-part-list.component.html',
    styleUrls: ['./ecat-mobile-part-list.component.less']
})
export class EcatMobilePartListComponent implements OnInit {
    @Input() showHeader: boolean = true;
    @Output() clearSearch = new EventEmitter<void>();
    @ViewChild('scrollContainer') scrollContainer!: ElementRef;
    @ViewChild('loadMoreAnchor') loadMoreAnchor!: ElementRef;
    // --- 1. 原始数据 (你提供的JSON) ---
    rawData: any[] = [];

    // --- 2. 状态控制 ---
    isHeaderExpanded: boolean = false;
    isFilterOpen: boolean = false;

    // --- 3. 页面数据源 ---
    categories: CategoryView[] = [];       // 左侧列表
    subCategories: SubCategoryView[] = []; // 右侧顶部Tab
    filterTags: SubCategoryView[] = [];    // 筛选弹窗列表 (与Category2一致)

    displayProducts: any[] = []; // 当前展示的产品
    partList: any[] = []; // 当前展示的产品

    RemarkMap: any = RemarkMap;
    // --- 4. 选中状态 ---
    selectedCategoryId: string = '';    // 当前选中的 Category1
    selectedSubCategoryId: string = 'all'; // 当前选中的 Category2 (Tab)

    // 筛选弹窗的状态
    tempSelectedFilterIds: Set<string> = new Set();
    activeFilterIds: Set<string> = new Set(); // 如果为空，表示未筛选
    isDealerPortal: boolean = false;


    Math = Math;
    parseFloat = parseFloat;
    // 车型模拟数据
    vehicleList: { carFullInfo: string; engineOilOeGuideline: string }[] = [];
    pageIndex = 1;
    pageSize = 10;
    isContentLoading = false;
    selectedSubCategoryIds = new Set<string>();
    searchValue: string = '';
    vinCode: string | null = '';
    searchBySelectedCars = false;
    selectedCarIds = '';
    selectedBrandId = '';

    loadingMore = false;   // 滚动加载 loading
    hasMore = true;
    isInitialLoading = true;
    paramsForLoadMore: any = {};
    isAllChecked = false;
    selectedLevelIds = '';

    private observer!: IntersectionObserver;

    constructor(private ecatService: EcatService,
        private router: Router,
        private modal: NzModalService,
        private message: NzMessageService,
        private sharedData: SharedDataService,
        private route: ActivatedRoute) {
        this.sharedData.currentData.subscribe(data => {
            this.isDealerPortal = data.isDealerPortal;
        });
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            const vin = params.get('vinCode');
            this.vinCode = vin;
            const searchByCar = history.state.searchBySelectedCars;
            this.searchBySelectedCars = searchByCar;
            if (vin) {
                this.searchByVin(vin);
            } else if (searchByCar) {
                const queryParams = history.state.queryParams;
                this.selectedCarIds = queryParams.carIds;
                this.isAllChecked = queryParams.isSelectAll === '1';
                const selectedCarInfos = history.state.selectedCarInfos;
                this.vehicleList = selectedCarInfos;
                this.selectedBrandId = queryParams.brandId;
                this.getCategorysAfterSearch(queryParams);
            } else {
                if (this.showHeader === true) {
                    this.router.navigate(['gb/cn/parts/ecat-search']);
                    return;
                }
                const queryParams = {
                    brandId: "",
                    carIds: "",
                    levelIds: "",
                    modelClass: "",
                    isSelectAll: "0",
                    displacement: "",
                    modelYear: "",
                    modelName: "",
                    maunufacturer: "",
                    languageType: "zh-cn"
                }
                this.getCategorys(queryParams);
            }
        });
    }

    ngAfterViewInit(): void {
        this.createObserver();
    }

    createObserver(): void {
        this.observer?.disconnect();

        this.observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    this.loadNextPage();
                }
            },
            {
                root: this.scrollContainer.nativeElement,
                threshold: 0.1
            }
        );

        this.observer.observe(this.loadMoreAnchor.nativeElement);
    }

    loadProducts(): void {
        this.pageSize = 10;
        this.displayProducts = [];
        this.hasMore = true;
        this.isInitialLoading = true;
    }

    /** 滚动加载 */
    loadNextPage(): void {
        if (
            this.loadingMore ||
            this.isInitialLoading ||
            !this.hasMore
        ) {
            return;
        }

        const paramsForLoadMore = this.paramsForLoadMore;
        paramsForLoadMore.pageSize = this.pageSize;
        this.getPartList(paramsForLoadMore, false);
    }

    getCategorys(selectedCarInfo: any): void {
        this.isContentLoading = true;
        this.ecatService.getCategoryByCarList(selectedCarInfo).subscribe(result => {
            const { resultCode, resultData } = result;
            this.rawData = resultData.categoryList;
            this.processRawData();
            this.isContentLoading = false;
            // 模拟生成产品数据（因为JSON只包含分类结构）
            // this.generateMockProductsFromCategories();

            // 默认选中第一个分类
            if (this.categories.length > 0) {
                this.selectCategory(this.categories[0].id);
            }
        })
    }

    getCategorysAfterSearch(selectedCarInfo: any): void {
        this.isContentLoading = true;
        this.ecatService.getCategoryByCarList(selectedCarInfo).subscribe(result => {
            const { resultCode, resultData } = result;
            this.rawData = resultData.categoryListForCar;
            const allCarInfo = resultData.allCarInfo;
            this.processRawData();
            this.isContentLoading = false;

            if (this.isAllChecked) {
                const output = allCarInfo.map((item: any) => {
                    return { "carFullInfo": item.carFullInfo, "engineOilOeGuideline": item.engineOilOeGuideline };
                });
                this.vehicleList = output;
                let carIdsForParts = '';
                allCarInfo.forEach((item: any) => {
                    carIdsForParts = carIdsForParts + "," + item.carId;
                });
                this.selectedCarIds = carIdsForParts;
            }

            // 默认选中第一个分类
            if (this.categories.length > 0) {
                this.selectCategory(this.categories[0].id);
            }
        })
    }

    goDetail(partId: number) {
        this.router.navigate([`gb/cn/parts/part-detail/${partId}`], {
            state:
            {
                isAllChecked: this.isAllChecked, selectedCarIds: this.selectedCarIds,
                selectedBrandId: this.selectedBrandId, partId: partId, searchBySelectedCars: this.searchBySelectedCars,
                selectedLevelIds: this.selectedLevelIds, vinCode: this.vinCode
            }
        });
    }

    searchByVin(vinCode: string): void {
        this.ecatService.queryVinCode({ vinCode: vinCode, languageType: 'zh-cn' }).subscribe(result => {
            const { resultCode, resultData, resultMsg } = result;
            if (resultCode !== '0') {
                this.router.navigate(['gb/cn/parts']);
                this.message.create('error', resultMsg);
            } else {
                this.vehicleList = resultData.carInfoList.map((item: any) => {
                    return { "carFullInfo": item.carFullInfo, "engineOilOeGuideline": item.engineOilOeGuideline };
                });
                const carIds = resultData.carIds;
                this.selectedCarIds = carIds;
                this.selectedLevelIds = resultData.levelIds;
                const selectedCarInfo = {
                    brandId: "",
                    carIds: carIds,
                    levelIds: resultData.levelIds,
                    modelClass: "",
                    isSelectAll: "0",
                    displacement: "",
                    modelYear: "",
                    modelName: "",
                    maunufacturer: "",
                    languageType: "zh-cn"
                }
                this.getCategorysAfterSearch(selectedCarInfo);
            }
        });
    }

    // --- 数据处理逻辑 ---
    processRawData() {
        const map = new Map<string, { order: number, name: string }>();

        this.rawData.forEach((item: any) => {
            if (item.category1Name && !map.has(item.category1Name)) {
                map.set(item.category1Name, {
                    name: item.category1Name,
                    order: item.wechatOrder || 99
                });
            }
        });

        // 转为数组并排序
        this.categories = Array.from(map.values())
            .sort((a, b) => a.order - b.order)
            .map(item => ({ id: item.name, name: item.name, order: item.order }));
    }

    getSubCategoriesForCurrentGroup(): any[] {
        let subs = [];
        if (this.vinCode || this.searchBySelectedCars) {
            const categorys = this.rawData.filter(item => item.category1Name === this.selectedCategoryId)
            subs = categorys.map((item: any) => item.category2Name);
        } else {
            const selectedCategory = this.rawData
                .find(item => item.category1Name === this.selectedCategoryId);
            const selectedSubCategory = selectedCategory.subList;
            subs = selectedSubCategory.map((item: any) => item.category2Name);
        }

        // 去重
        const uniqueSubs = Array.from(new Set(subs));
        return uniqueSubs.map(name => ({ id: name, name: name }));
    }

    getImage(imageList: any) {
        if (imageList.length > 0) {
            return 'https://spiderbeast2.blob.core.chinacloudapi.cn/pim-attachment/' + imageList[0].imageName;
        } else {
            return 'assets/official-website/no-image.png'
        }
    }

    // --- 交互逻辑 ---

    toggleHeader() {
        this.isHeaderExpanded = !this.isHeaderExpanded;
        if (this.isHeaderExpanded) this.isFilterOpen = false;
    }

    reChoose() {
        this.router.navigate(['gb/cn/parts']);
    }

    updateSubCategory(catId: string) {
        this.selectedSubCategoryIds = new Set<string>();

        // 1. 更新右侧顶部 Tab 数据
        const subs = this.getSubCategoriesForCurrentGroup();
        this.subCategories = [{ id: 'all', name: '全部' }, ...subs];

        // 2. 更新筛选弹窗数据
        this.filterTags = [...subs];

        // 3. 重置右侧选中状态
        this.selectedSubCategoryId = catId;
        this.selectedSubCategoryIds.add(catId);
        this.activeFilterIds.clear();
    }

    // 点击左侧分类
    selectCategory(catId: string) {
        this.selectedSubCategoryIds = new Set<string>();
        this.loadProducts();
        this.clearSearch.emit();
        if (this.selectedCategoryId !== catId) {
            this.displayProducts = [];
        }
        this.selectedCategoryId = catId;

        // 1. 更新右侧顶部 Tab 数据
        const subs = this.getSubCategoriesForCurrentGroup();
        this.subCategories = [{ id: 'all', name: '全部' }, ...subs];

        // 2. 更新筛选弹窗数据
        this.filterTags = [...subs];

        // 3. 重置右侧选中状态
        this.selectedSubCategoryId = 'all';
        this.activeFilterIds.clear();

        this.toggleSubCategory({ id: 'all', name: '全部' })
        if (environment.production) {
            const userData = JSON.parse(localStorage.getItem('userData') || '{}');
            const customer = JSON.parse(localStorage.getItem('customer') || '{}');
            (window as any).dataLayer.push({
                event: 'dp_ecat_cat_click',
                from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                event_type: this.searchBySelectedCars ? this.vehicleList : '',
                event_name: '',
                portal_name: 'Mobile ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
                event_content: catId,
            });
        }
    }

    // 点击右侧顶部 Tab
    toggleSubCategory(subCategory: any) {
        this.loadProducts();
        this.clearSearch.emit();
        const subId = subCategory.id;

        // ===================
        // 多选切换逻辑
        // ===================
        if (subId === 'all') {
            this.selectedSubCategoryIds.clear();
            this.selectedSubCategoryIds.add('all');
        } else {
            this.selectedSubCategoryIds.delete('all');

            if (this.selectedSubCategoryIds.has(subId)) {
                this.selectedSubCategoryIds.delete(subId);
            } else {
                this.selectedSubCategoryIds.add(subId);
            }

            if (this.selectedSubCategoryIds.size === 0) {
                this.selectedSubCategoryIds.add('all');
            }
        }

        // ===================
        // 排序：保持选中的在前
        // ===================
        this.sortSubCategoriesBySelection();

        // ===================
        // 同步到筛选条件 & 搜索逻辑
        // ===================
        this.activeFilterIds.clear();
        this.selectedSubCategoryIds.forEach(id => {
            if (id !== 'all') this.activeFilterIds.add(id);
        });

        let names = [...this.selectedSubCategoryIds]
            .map(id => this.subCategories.find(x => x.id === id)?.name)
            .filter(Boolean)
            .join(',');

        if (names === '全部') {
            names = this.subCategories
                .filter(item => item.id !== 'all')
                .map(item => item.name)
                .join(',');
        }

        this.onSearchByCategory2Names(names);
        if (subId !== 'all') {
            if (environment.production) {
                const userData = JSON.parse(localStorage.getItem('userData') || '{}');
                const customer = JSON.parse(localStorage.getItem('customer') || '{}');
                (window as any).dataLayer.push({
                    event: 'dp_ecat_cat_click',
                    from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                    event_type: this.searchBySelectedCars ? this.vehicleList : '',
                    event_name: '',
                    portal_name: 'Mobile ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
                    event_content: subId,
                });
            }
        }
    }

    private sortSubCategoriesBySelection() {
        this.subCategories = [
            // 1. 全部永远在最前
            ...this.subCategories.filter(x => x.id === 'all'),

            // 2. 已选中的（排在前面）
            ...this.subCategories.filter(
                x => x.id !== 'all' && this.selectedSubCategoryIds.has(x.id)
            ),

            // 3. 未选中的（排在后面）
            ...this.subCategories.filter(
                x => x.id !== 'all' && !this.selectedSubCategoryIds.has(x.id)
            ),
        ];
    }


    // --- 筛选弹窗逻辑 ---

    openFilter() {
        // 同步当前选中的 Tab 到 Filter 中 (如果是 All 则不选，如果是特定项则选中)
        this.tempSelectedFilterIds = new Set();

        // 如果当前通过 Tab 选中了某个 specific，或者之前通过 Filter 选中了多个
        if (this.activeFilterIds.size > 0) {
            this.activeFilterIds.forEach(id => this.tempSelectedFilterIds.add(id));
        } else if (this.selectedSubCategoryId !== 'all') {
            this.tempSelectedFilterIds.add(this.selectedSubCategoryId);
        }

        this.isFilterOpen = true;
        this.isHeaderExpanded = false;
    }

    closeFilter() {
        this.isFilterOpen = false;
    }

    toggleFilterTag(id: string) {
        if (this.tempSelectedFilterIds.has(id)) {
            this.tempSelectedFilterIds.delete(id);
        } else {
            this.tempSelectedFilterIds.add(id);
        }
    }

    clearFilters() {
        this.tempSelectedFilterIds.clear();
    }

    confirmFilters() {
        // 1. 覆盖正式选中
        this.selectedSubCategoryIds = new Set(this.tempSelectedFilterIds);

        // 2. 同步 activeFilterIds
        this.activeFilterIds = new Set(this.selectedSubCategoryIds);


        // 4. 调用搜索（名称用逗号拼接）
        let names = [...this.selectedSubCategoryIds]
            .map(id => this.subCategories.find(x => x.id === id)?.name)
            .filter(Boolean)
            .join(',');

        if (names === '') {
            this.selectedSubCategoryIds = new Set(['all']);
            this.activeFilterIds = new Set(['all']);
            names = this.subCategories
                .filter(item => item.id !== 'all')
                .map(item => item.name)
                .join(',');
        }
        // 3. 重新排序：选中的放前面, 未选中的放后面
        this.sortSubCategoriesBySelection();

        this.onSearchByCategory2Names(names);


        // 6. 关闭弹窗
        this.closeFilter();
    }

    fetchData(): void {
        this.clearFilters();
        this.activeFilterIds.clear();
        this.selectedSubCategoryIds.clear();
        this.selectedCategoryId = '';
        const params = {
            page: this.pageIndex,
            pageSize: this.pageSize,
            partNo: encryptParam(this.searchValue),
            // category2Names: encryptParam(''),
            languageType: encryptParam('zh-cn'),
        }
        this.getPartList(params, true)
    }

    onSearchByCategory2Names(category2Names: string) {
        let params = {};
        if (this.vinCode) {
            params = {
                page: this.pageIndex,
                pageSize: this.pageSize,
                category2Names: encryptParam(category2Names),
                levelIds: encryptParam(this.selectedLevelIds),
                carIds: encryptParam(this.selectedCarIds),
                languageType: encryptParam('zh-cn'),
            }
        } else if (this.searchBySelectedCars) {
            params = {
                page: this.pageIndex,
                pageSize: this.pageSize,
                category2Names: encryptParam(category2Names),
                carIds: encryptParam(this.selectedCarIds),
                languageType: encryptParam('zh-cn'),
            }
        } else {
            params = {
                page: this.pageIndex,
                pageSize: this.pageSize,
                partNo: encryptParam(''),
                category2Names: encryptParam(category2Names),
                languageType: encryptParam('zh-cn'),
            }
        }
        this.paramsForLoadMore = params;
        this.getPartList(params, false);
    }

    getPartList(params: any, searchByPartNo: boolean) {
        this.loadingMore = true;
        this.ecatService.partList(params).subscribe(result => {
            const { resultCode, resultData } = result;
            // this.pageInfo = resultData.pageInfo;
            this.displayProducts = resultData.partList;
            this.partList = resultData.partList;
            this.displayProducts.forEach((item: any) => {
                item.partFeatureValueList && item.partFeatureValueList.forEach((feature: any) => {
                    if (feature.featureNameCn === '雨刮1长度' || feature.featureNameCn === '雨刮2长度(仅套装)' || feature.featureNameCn === '长度 1' || feature.featureNameCn === '长度 2') {
                        const regex = /(\d+(\.\d+)?)/
                        const match = feature.featureValue.match(regex)
                        if (match) {
                            const number = parseFloat(match[0])
                            const roundedNumber = number / 25.4
                            const unit = feature.featureValue.replace(match[0], '')
                            feature.featureValue = `${roundedNumber}${unit}`
                        }
                    }
                })
            })

            if (searchByPartNo) {
                this.selectedCategoryId = resultData.partList[0].category1Name;
                this.updateSubCategory(resultData.partList[0].category2Name);
            }

            this.hasMore = resultData.partList.length === this.pageSize;
            this.pageSize = this.pageSize + 10;

            this.loadingMore = false;
            this.isInitialLoading = false;
        })
    }

    copyText(numner: string) {
        if (copy(numner)) {
            this.message.create('success', '复制成功');
        } else {
            this.message.create('error', '复制失败');
        }
    }

    hasVideoUrl(categoryName: string, remark: string) {
        return RemarkMap[categoryName as keyof typeof RemarkMap]?.[remark as keyof typeof RemarkMap[keyof typeof RemarkMap]];
    }
    openVideoModal(categoryName: string, remark: string): void {
        let videoUrl = RemarkMap[categoryName as keyof typeof RemarkMap]?.[remark as keyof typeof RemarkMap[keyof typeof RemarkMap]];
        this.modal.create({
            nzTitle: '视频播放',
            nzContent: VideoModalComponent,
            nzComponentParams: {
                videoUrl: videoUrl
            },
            nzFooter: null,
            nzWidth: 800
        });
    }


    getRemarks(remark: string, categoryName: string) {
        return EcatUtils.mapRemark(remark, categoryName);
    }

    ifRemarkExist(remarkExternalList: any) {
        if (remarkExternalList && remarkExternalList.length > 0) {
            if (remarkExternalList.length === 1) {
                if (remarkExternalList[0] === '') {
                    return false;
                } else {
                    return true;
                }
            }
            return true;
        } else {
            return false;
        }
    }

    isVideoModal(remark: any) {
        const nonVideoList = ['AP1', 'AP3', 'AP4', 'AP6', '2AA', '2BB', '2CC', '1A', '1B', '2A', '2C'];
        if (nonVideoList.includes(remark)) {
            return true;
        } else {
            return false;
        }
    }

    filterFeature(partList: any) {
        let displayFeature1Name
        let displayFeature2Name
        let featureLengths = []
        // 雨刮长度
        // const rainWiperName1 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮1长度')
        // const rainWiperName2 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮2长度(仅套装)')
        // 长度 (英寸)
        const rainWiperName1 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 1（英寸）')
        const rainWiperName2 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 2（英寸）')

        if (rainWiperName1 || rainWiperName2) {
            displayFeature1Name = partList.partFeatureValueList.filter((feature: any) => feature.featureNameCn !== '长度 1' && feature.featureNameCn !== '长度 2' && feature.featureNameCn !== '雨刮1长度' && feature.featureNameCn !== '雨刮2长度(仅套装)')
            featureLengths = displayFeature1Name
        } else {
            // 长度 (mm)
            // const rainWiperName3 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 1')
            // const rainWiperName4 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 2')
            // 雨刮长度
            const rainWiperName3 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮1长度')
            const rainWiperName4 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮1长度')
            if (rainWiperName3 || rainWiperName4) {
                // 长度 (英寸)
                displayFeature2Name = partList.partFeatureValueList.filter((feature: any) => feature.featureNameCn !== '长度 1' && feature.featureNameCn !== '长度 2')
                featureLengths = displayFeature2Name
            } else {
                featureLengths = partList.partFeatureValueList
            }
        }
        return featureLengths
    };

    editFeatureNameCn(featureNameCn: any, partNo: any): string {
        if (!featureNameCn) {
            return ''; // Return empty string instead of undefined
        }

        const item = this.partList.find(item => item.partNo === partNo); // `.find` is cleaner than `.filter()[0]`
        if (!item) {
            return ''; // Handle case where item is not found
        }

        const isAllSize1 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '雨刮1长度')
            && item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '雨刮2长度(仅套装)');
        const isAllSize2 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 1')
            && item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 2');
        const isAllSize3 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 1（英寸）')
            && item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 2（英寸）');
        const isOnlySize1 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '雨刮1长度');
        const isOnlySize2 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 1');
        const isOnlySize3 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 1（英寸）');

        // 英寸存在
        if (isAllSize3) {
            if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
                return '主驾尺寸(英寸)';
            } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
                return '副驾尺寸(英寸)';
            }
        }
        // 雨刮长度存在
        else if (isAllSize1) {
            if (isOnlySize3) {
                return '尺寸(英寸)';
            } else {
                if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
                    return '主驾尺寸(英寸)';
                } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
                    return '副驾尺寸(英寸)';
                }
            }
        }
        // mm存在
        else if (isAllSize2) {
            if (isOnlySize1 || isOnlySize3) {
                return '尺寸(英寸)';
            } else {
                if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
                    return '主驾尺寸(英寸)';
                } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
                    return '副驾尺寸(英寸)';
                }
            }
        }
        // 仅存在英寸
        else if (isOnlySize3) {
            return '尺寸(英寸)';
        }
        // 仅存在雨刮长度
        else if (isOnlySize1) {
            if (!isAllSize3) {
                return '尺寸(英寸)';
            } else {
                if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
                    return '主驾尺寸(英寸)';
                } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
                    return '副驾尺寸(英寸)';
                }
            }
        }
        // 仅存在mm
        else if (isOnlySize2) {
            if (!isAllSize1 && !isAllSize3) {
                return '尺寸(英寸)';
            } else {
                if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
                    return '主驾尺寸(英寸)';
                } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
                    return '副驾尺寸(英寸)';
                }
            }
        }
        return ''; // Default return if none of the conditions match
    };
}